export enum SellerPromotionValueType {
  FlatRate = 'FLAT_RATE',
  RateDiscount = 'RATE_DISCOUNT',
  ReplacementRate = 'REPLACEMENT_RATE',
}

export const InboxReminderTooltipCookie = 'inbox_reminder_tooltip_count';
